import React from 'react';
import PropTypes from 'prop-types';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';
import modal from '~components/modal';
import { Video as VideoIcon } from 'common/components/svgs';
import { imageUrl, getLocale } from '~helpers/gallery';
import { imageSizes } from '~constants/gallery';

@modal()
export default class SendForApprovalModal extends React.PureComponent {
  render() {
    const { t, waitingApprovalData, isLoading } = this.props;
    const { images, videos, links } = waitingApprovalData;

    return (
      <div className="send-for-approval-modal">
        <div className="send-for-approval-modal__title">
          {t('cms:cms.pending_approval.title.waiting_list')}
          <button
            type="button"
            className="send-for-approval-modal__close"
            onClick={this.props.onCloseModal}
          >
            <CloseOutlined style={{ fontSize: '12px' }} />
          </button>
        </div>
        <div className="send-for-approval-modal__content">
          <div className="send-for-approval-modal__description">
            {t('cms:cms.pending_approval.description.send_for_approval')}
          </div>
          <If condition={images && images.length > 0}>
            <div className="send-for-approval-modal__category-title">
              {t('cms:cms.pending_approval.title.photo')}
            </div>
            <div className="send-for-approval-modal__image-wrap">
              <For each="image" of={images} index="index">
                <img
                  key={index}
                  alt={image.filename || ''}
                  className="send-for-approval-modal__image-item"
                  src={imageUrl(image, imageSizes.big)}
                />
              </For>
            </div>
          </If>
          <If condition={videos && videos.length > 0}>
            <div className="send-for-approval-modal__category-title">
              {t('cms:cms.pending_approval.title.video')}
            </div>
            <div className="send-for-approval-modal__video-wrap">
              <For each="video" of={videos} index="index">
                <div key={index} className="send-for-approval-modal__video-item">
                  <span className="send-for-approval-modal__video-tag">
                    <VideoIcon className="send-for-approval-modal__video-icon" />
                    {t('cms:cms.pending_approval.tag.video')}
                  </span>
                  <span className="send-for-approval-modal__label-wrap">
                    <span>{t('cms:cms.pending_approval.label.video_link')}</span>
                    <span>{t('cms:cms.pending_approval.label.locale')}</span>
                  </span>
                  <span className="send-for-approval-modal__text-wrap">
                    <Tooltip
                      placement="top"
                      overlayStyle={{ zIndex: '1000000' }}
                      title={
                        video.links ? video.links.hqMp4 : t('cms:cms.file_compressing.description')
                      }
                    >
                      <span>
                        {video.links
                          ? video.links.hqMp4
                          : t('cms:cms.file_compressing.description')}
                      </span>
                    </Tooltip>
                    <span>{getLocale(video.locales)}</span>
                  </span>
                </div>
              </For>
            </div>
          </If>
          <If condition={links && links.length > 0}>
            <div className="send-for-approval-modal__category-title">
              {t('cms:cms.pending_approval.title.virtual_tour')}
            </div>
            <div className="send-for-approval-modal__link-wrap">
              <For each="link" of={links} index="index">
                <div key={index} className="send-for-approval-modal__link-item">
                  <span className="send-for-approval-modal__label-wrap">
                    <span>{t('cms:cms.pending_approval.label.link_address')}</span>
                    <span>{t('cms:cms.pending_approval.label.locale')}</span>
                  </span>
                  <span className="send-for-approval-modal__text-wrap">
                    <Tooltip placement="top" overlayStyle={{ zIndex: '1000000' }} title={link.link}>
                      <span>{link.link}</span>
                    </Tooltip>
                    <span>{link.displayRegion}</span>
                  </span>
                </div>
              </For>
            </div>
          </If>
        </div>
        <div className="send-for-approval-modal__footer">
          <Button
            type="primary"
            size="large"
            onClick={this.props.onSendForApproval}
            loading={isLoading}
          >
            {t('cms:cms.pending_approval.btn.send_for_approval')}
          </Button>
        </div>
      </div>
    );
  }
}

SendForApprovalModal.propTypes = {
  t: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
  waitingApprovalData: PropTypes.object,
  onSendForApproval: PropTypes.func,
  isLoading: PropTypes.bool,
};

SendForApprovalModal.defaultProps = {
  t: () => {},
  onCloseModal: () => {},
  waitingApprovalData: {},
  onSendForApproval: () => {},
  isLoading: false,
};
